<app-section width="1600px">
    <div class="grid" [hidden]="viewing != 'main'">
        <div class="recipe main" *ngFor="let recipe of recipes?.main">
            <img *ngIf="recipe" [src]="(recipe.image?.host || '') + (recipe.image?.path || '')  + '?fit=crop&w=300&h=300&auto=format&crop=focalpoint&fp-z=1.1'" alt="">
            <h2 *ngIf="recipe">{{ recipe.name }}</h2>
        </div>
    </div>
</app-section>